module.exports = __webpack_public_path__ + "img/louisxiii-white.8caca0cb.svg";